import { render, staticRenderFns } from "./andonType.vue?vue&type=template&id=62877441&"
import script from "./andonType.vue?vue&type=script&lang=js&"
export * from "./andonType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports